import React from 'react';

export default class ZooNoResultsFound extends React.Component {
	render() {
		return (
			<div className="ZooNoResultsFound">
				<img alt="No results found" src="/images/noresults.jpg" />
				<h4>what we have here<br/>with respect to the number of results<br/>is the opposite of infinity, folks</h4>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ZooNoResultsFound.js